import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import editWorkorderParent from './parent.vue';

var EditWorkOrderPage = function (_super) {
  __extends(EditWorkOrderPage, _super);

  function EditWorkOrderPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  EditWorkOrderPage = __decorate([Component({
    components: {
      editWorkorderParent: editWorkorderParent
    }
  })], EditWorkOrderPage);
  return EditWorkOrderPage;
}(Vue);

export default EditWorkOrderPage;